export default __webpack_public_path__ + "static/media/box.83e4cc0b.svg";